import React, { useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import { useTranslation } from 'react-i18next';

import startMap from './startMap';
import * as S from './styled';

const Geolocation = ({ geoData, setMap, map }) => {
  const { DMS, lat, lng } = geoData;

  const { t } = useTranslation();

  const mapContainer = useRef(null);

  useEffect(() => {
      setMap(startMap(lat, lng, mapContainer));
  }, []);

  useEffect(() => {
    if (map) {
      map.setCenter([`${lng}`, `${lat}`]);
      new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: false,
          },
          trackUserLocation: true,
          showUserLocation: true,
        })
      );
    }
  }, [geoData, map]);

  return (
    <S.GeoBlock>
      <S.Map id="map" ref={mapContainer} />
      <S.Coordinate>{`${t('lat')}: ${DMS.lat} ${t('lng')}: ${DMS.lng}`}</S.Coordinate>
    </S.GeoBlock>
  );
};

Geolocation.defaultProps = {
  map: null,
  geoData: null,
};

Geolocation.propTypes = {
  map: PropTypes.shape({}),
  setMap: PropTypes.func.isRequired,
  geoData: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    DMS: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
    location: PropTypes.string,
    offsetSec: PropTypes.number,
  }),
};

export default memo(Geolocation);
